import { useApiBackendInfo } from '@/hooks/query';
import { CFS } from '@/utils/cfsEncodeFunc';
import { RSACrypt } from '@/utils/rsa-provider';
import { ApiResponse } from '@nf/types/api';
import { fetchComposer } from '@nf/utils-common/compose-fetch';
import { Box } from '@nf/utils-common/fpw/monadic';

export function useChangePassword () {
	const { url, token } = useApiBackendInfo();
	async function getPublicKey (): Promise<{
		EKEY?: string,
		MKEY?: string,
	}> {
		try {
			const  response = await fetchComposer.get(`${url}/Config/GetRsaPublicKey`);
			const  data = await response.json();
			if (data.ErrorCode == 0) {
				return {
					EKEY: data?.Data?.Exponent,
					MKEY: data?.Data?.Modulus,
				};
			} else {
				throw new Error('getPublicKey Error');
			}
		} catch (e) {
			throw e
		}
	}

	async function savePasword(currentPassword: string, newPassword: string): Promise<boolean> {
		try {
			const { EKEY, MKEY } = await getPublicKey();
			if (!EKEY || !MKEY) {
				throw new Error('Failed to retrieve public keys.');
			}
			const provider = new RSACrypt(EKEY, MKEY, 1024);
			const encrypteCurrentPassword = Box(currentPassword)
				.map((str: string) => CFS(str))
				.map((str: string) => provider.encryptedString(str))
				.extract();
			const encrypteNewPassword = Box(newPassword)
				.map((str: string) => CFS(str))
				.map((str: string) => provider.encryptedString(str))
				.extract();
	
			if (!token) {
				throw new Error('Authentication token not found.');
			}
			
			const response = await fetchComposer.postWithBearer(
				`${url}/ManageAccount/UpdatePassword`,
				{
					body: JSON.stringify({
						currentPassword: encrypteCurrentPassword,   
						newPassword: encrypteNewPassword
					}),
				}
			)(token);
			const data: ApiResponse = await response.json();
			if (data?.errorCode === 0) {
				return true;
			} else if (data?.errorCode === 1) {
				throw new PasswordSameError();
			}	else if (data?.errorCode === 2) {
				throw new PasswordIncorrrectError();
			} else {
				throw new Error();
			}
		} catch (e) {
			throw e
		}
	}
	
	return {
		savePasword
	}
}

export class PasswordSameError extends Error {};
export class PasswordIncorrrectError extends Error {};
